import { Component } from '@angular/core';
import { ConfigService } from '../../modules/common-shared-module/core/services/config/config.service';

/**
 * Static 404 page. It is rendered by the wildcard route ('**') of the app routing.
 * The app shell (app.component) doesn't paint its own toolbar for this route (data.notFound = true),
 * so this component draws a reduced header: logo + entity / user, without any menu or entity selector.
 */
@Component({
	selector: 'app-not-found',
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

	public showPreprodIndicator: boolean = false

	constructor(public configService: ConfigService) {
		this.showPreprodIndicator = !configService.config.isProduction()
	}

}
